import React from 'react';
import { Link } from 'react-router-dom';
import Card from '@mui/material/Card/Card';
import { alpha, Box, CardActionArea, Typography } from '@mui/material';
import { SvgIconProps } from '@mui/material/SvgIcon/SvgIcon';
import TableChartIcon from '@mui/icons-material/TableChart';
import { AdminPanelSecObjects } from 'src/types/security';

export type LinkCardProps = {
    to: string;
    icon?: React.FC<SvgIconProps>;
    title: React.ReactNode;
    color?: string;
    securityObject: AdminPanelSecObjects;
};

function LinkCard({ to, icon, title, color = '#4f46e5' }: LinkCardProps) {
    const CardIcon: React.FC<SvgIconProps> = icon ? icon : TableChartIcon;

    return (
        <Link to={to} style={{ textDecoration: 'none' }}>
            <Card
                sx={{
                    borderRadius: '16px',
                    border: '1px solid',
                    borderColor: 'divider',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
                    transition: 'all 0.25s ease',
                    '&:hover': {
                        transform: 'translateY(-6px)',
                        boxShadow: `0 16px 32px ${alpha(color, 0.22)}`,
                        borderColor: color,
                    },
                }}
            >
                <CardActionArea sx={{ p: 3 }}>
                    <Box
                        sx={{
                            width: 56,
                            height: 56,
                            borderRadius: '14px',
                            bgcolor: alpha(color, 0.12),
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mb: 2,
                            transition: 'background-color 0.25s ease',
                            '.MuiCardActionArea-root:hover &': {
                                bgcolor: alpha(color, 0.2),
                            },
                        }}
                    >
                        <CardIcon sx={{ fontSize: '2rem', color }} />
                    </Box>
                    <Typography
                        sx={{
                            fontSize: '1rem',
                            fontWeight: 700,
                            color: 'text.primary',
                            lineHeight: 1.3,
                        }}
                    >
                        {title}
                    </Typography>
                </CardActionArea>
            </Card>
        </Link>
    );
}

export default LinkCard;